import React from 'react';

import styled from '@emotion/styled';

import {
  GovIdUploadDataType,
  GovIdUploadInitialValues,
  GovIdUploadSchema,
} from '../../../models/dashboard/settings/profileSettings/UploadGovId.model';
import ValidatingFormSubmitButton from '../../Button/FormSubmitButton';
import { FormComponent } from '../../Form/FormComponent';
import ModalContainer from '../ModalContainer';
import CustomFileUploader from '../../Form/CustomFileUploader';
import ChevronRightIcon from '../../Icons/ChevronRightIcon';
import useUploadGovId from '../../../hooks/dashboard/settings/profilesetting/useUploadGovId';
import { useAppSelector } from '../../../redux/store';
import { ModalContext } from '../../../context/ModalContext';
import { useContext } from 'react';

// .......................................

const UploadGovIdModal = () => {
  const { loading, uploadGovId } = useUploadGovId();
  const { authData } = useAppSelector((state) => state.auth);
  const modalContext = useContext(ModalContext);

  const handleOnSubmit = (values: GovIdUploadDataType, actions: any) => {
    // applyToJobPostWithResume(values, jobId || '', jobCreatorId, () =>
    //   actions.resetForm({ values: applyToJobPostWithResumeInitialValues })
    // );
    uploadGovId(values);
  };

  const rejected =
    authData?.governmentIdStatus === 'Rejected' &&
    authData?.governmentId !== null;

  const onClickContinue = (e: any) => {
    modalContext?.displayModal(false);
    console.log('clickk');
  };

  return (
    <ModalContainer width="761px" padding="25px 41px 55px" marginTop="164px">
      <Container>
        <FormComponent
          initialValues={GovIdUploadInitialValues}
          schema={GovIdUploadSchema}
          onSubmit={handleOnSubmit}
        >
          <InputsArea>
            <InputDescription>
              <div>
                {rejected ? <Rej>GOV ID REJECTED</Rej> : 'UPLOAD GOV ID'}
              </div>
              <div>
                Please upload a {rejected && <Rej>proper</Rej>} government
                issued ID so we can upgrade you to a TIER 2 user. You can also
                do this later in your user account settings if you don’t have
                one now.
              </div>
            </InputDescription>

            <FormInputs>
              {/* <CustomSelectField
                id="governmentId"
                name="governmentId"
                // optionData={['Pharma.pdf', 'Dentist.jpeg', 'Doctor.png']}
                optionData={[]}
              /> */}

              <CustomFileUploader label="" name="governmentId" modal />
              <ValidatingFormSubmitButton className="small2" loading={loading}>
                {loading ? 'Uploading...' : ' Upload'}
              </ValidatingFormSubmitButton>
            </FormInputs>
          </InputsArea>
        </FormComponent>
      </Container>
      <Continue onClick={onClickContinue}>
        Continue later <ChevronRightIcon />
      </Continue>
    </ModalContainer>
  );
};

export default UploadGovIdModal;

const Container = styled.div`
  display: flex;
  margin-top: -32px;
`;

const InputsArea = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

const InputDescription = styled.div`
  display: flex;
  flex-direction: column;
  font-weight: 400;
  font-size: 14px;
  color: ${({ theme }) => theme.palette.blackBlack2};

  & > div:last-of-type {
    color: ${({ theme }) => theme.palette.greyGrey2};
  }
`;

const FormInputs = styled.div`
  display: flex;
  justify-content: center;
  align-items: end;
  width: 100%;
  gap: 8px;

  @media (max-width: 540px) {
    flex-direction: column;
  }
`;

const Continue = styled.p`
  color: ${({ theme }) => theme.palette.mainBlue};
  font-size: 18px;
  display: flex;
  justify-content: end;
  align-items: center;
  font-weight: 400;
  gap: 1rem;
  cursor: pointer;

  & svg {
    color: inherit;
  }
`;

const Rej = styled.span`
  color: red;
`;
